// коды акций с промокодами, детальные страницы которых закрыты от индексации
export const NOINDEX_STOCK_CODES: readonly string[] = [
    'svoy-vkus',
    'dlya-kazhdogo-nastroeniya',
    'tri-dnya-keshbeka-do-15000-bonusov',
    'tri-dnya-keshbeka-do-30000-bonusov',
    'tri-dnya-keshbeka-do-45000-bonusov',
];
